/* eslint-disable @typescript-eslint/ban-ts-comment */
import { ChangeService } from "@/@types/changeservice";
import { ChangeDateSelection, Choice, PropertyTypes, Reason, State } from "./context";
import { isMaxLength } from "@/shared/utils/utils";
import { isStreetNumber, validateE164Phone } from "@/shared/validations/validations";
import { isPostalCode } from "@/shared/validations/validations";
export const validateAccountHolder = (state: State) => {
  const fields = [state.firstname.value, state.lastname.value, state.birthday.value];
  if (!isFilled(fields)) {
    return false;
  }
  return true;
};

export const validateDeliveryAddress = (state: State, changeService?: ChangeService) => {
  const fields: Array<string | number | undefined | [string, string, string]> = [
    state.postalcode.value,
    state.location.value,
    state.location.id,
    state.street.value,
    state.streetNumber.value,
  ];

  if (state.propertyType === PropertyTypes.COMPANY) {
    fields.push(state.companyName.value, state.taxId.value, state.legalForm.value);
  }

  if (changeService?.counterNumber) {
    fields.push(state.counterNumber.value);
  }

  if (state.sameAsDelivery === Choice.NO) {
    fields.push(
      state.differentFirstname?.value,
      state.differentLastname?.value,
      state.differentBirthday?.value,
      state.differentPostalcode?.value,
      state.differentLocation?.id,
      state.differentLocation?.value,
      state.differentStreet?.value,
      state.differentStreetNumber?.value
    );
    if (state.propertyType === PropertyTypes.COMPANY) {
      fields.push(state.differentCompanyName?.value);
    }
  }
  if (!isFilled(fields)) {
    return false;
  }

  return true;
};

export const validateConsumption = (state: State, changeService?: ChangeService) => {
  const fields: Array<string | number | undefined | [string, string, string]> = [
    state.consumption.value,
    state.provider.categoryId,
    state.provider.categoryProviderId,
  ];

  if (changeService?.customerNumber) {
    fields.push(state.customerNumber?.value);
  }

  if (state.reason !== Reason.SWITCH_PROVIDER || state.changeDate.value !== ChangeDateSelection.NEXT_POSSIBLE_DATE) {
    fields.push(state.changeDate.dateTmp);
  }

  if (!isFilled(fields)) {
    return false;
  }

  return true;
};
const isOptionalPostalcode = (postalcode: string) => (postalcode || undefined) && isPostalCode(postalcode);
// eslint-disable-next-line
const evaluate = (value: any) => (validators: any) =>
  // eslint-disable-next-line
  validators.map((validator: any) => validator(value)).find((error: string) => error);
export const validateCompanyName = (name?: string) => evaluate(name)([isMaxLength(60)]);
export const validatePostalcode = (postalcode?: string) => evaluate(postalcode)([isOptionalPostalcode]);
export const validateStreetNumber = (number?: string) => (number ? evaluate(number)([isStreetNumber]) : undefined);
export const validatePhone = (number?: string) => number && evaluate(number)([validateE164Phone]);

export const validateBank = (state: State) => {
  const fields: Array<string | number | undefined | [string, string, string]> = [];

  // just check these fields if one of them is filled
  if (state.ibanOld.value || state.ibanNew.value || state.ibanNewRepeat.value) {
    fields.push(state.ibanOld.value, state.ibanNew.value, state.ibanNewRepeat.value);
  }

  if (state.differentAccountHolder === Choice.YES) {
    fields.push(
      state.differentAccountHolderFirstname?.value,
      state.differentAccountHolderLastname?.value,
      state.differentAccountHolderBirthday?.value,
      state.differentAccountHolderPostalcode?.value,
      state.differentAccountHolderLocation?.id,
      state.differentAccountHolderLocation?.value,
      state.differentAccountHolderStreet?.value,
      state.differentAccountHolderStreetNumber?.value,
      state.differentAccountHolderCompanyName?.value,
      state.differentAccountHolderTaxId?.value
    );
  }

  return true;
};

const isFilled = (arr: Array<string | number | undefined | Array<string>>) => {
  let result = true;
  for (let i = 0; i < arr.length; i++) {
    if (Array.isArray(arr[i])) {
      for (let j = 0; j < (arr[i] as Array<string>).length; j++) {
        // @ts-ignore
        if (!arr[i][j]) {
          result = false;
          break;
        }
      }
    } else {
      if (!arr[i]) {
        result = false;
        break;
      }
    }
  }
  return result;
};
